import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Card, CardBody, Container, Input, Button, Label, Row, Col, Form, FormGroup } from 'reactstrap';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import { getActiveUserListAPIURL, getUserWiseDurationReportAPIURL } from 'BaseComponentAPI/UserWiseDurationReportAPI';
import { getUserListForCallAvailabilityAPIURL } from 'BaseComponentAPI/CallAvailability';
import axios from 'axios';
import { useFormik } from 'formik';
import TableContainer from 'components/Common/TableContainer';
import * as Yup from 'yup';
import Select from 'react-select';
import moment from 'moment';
import Spinners from 'components/Common/Spinner';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import * as XLSX from 'xlsx';  // Import the xlsx library
import { checkPermissions } from 'components/Common/ChkPermissions';
import CantAccessPage from 'components/Common/CantAccessPage';
import { downloadUserAudioRecordingAPIURL, getUserAudioRecordingsAPIURL, streamUserAudioRecordingAPIURL } from 'BaseComponentAPI/UserAudioRecordingsAPI';
import downloadImg from './download.png'
import { FaDownload } from 'react-icons/fa';

<style>
    {`
  .datepicker-popper {
    margin-top: 4px !important;   /* ⭐ reduced gap */
    z-index: 9999;
  }

  /* Fix triangle alignment */
  .react-datepicker__triangle {
    left: 50% !important;
    transform: translateX(-50%);
  }

  .react-datepicker {
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    border: none;
  }
`}
</style>



const UsersAudioRecordings = () => {

    const authUser = useSelector(state => state.Login);
    document.title = "Cockpit";

    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
    const [popupType, setPopupType] = useState('');  // Set the type from passed state
    const [audioSrc, setAudioSrc] = useState(null);
    // console.log(audioSrc)
    const [audioSources, setAudioSources] = useState({}); // { uuid: url }
    const audioRefs = useRef({});



    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };


    const columns = useMemo(
        () => [
            {
                header: "Sr. No.",
                accessorKey: "seqNo",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "File Creation Time",
                accessorKey: "deviceFileCreationDateTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "File Upload Time",
                accessorKey: "uploadDateTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Communication To",
                accessorKey: "communicationDetails",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Device File Name",
                accessorKey: "deviceFileName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "File Size",
                accessorKey: "fileSize",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => {
                    const userFileUUID = row.original.userFileUUID;
                    const src = audioSources[userFileUUID];

                    return (
                        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                            {/* ✅ Show download button only if audio not loaded */}
                            {!src && (
                                <Button
                                    color="success"
                                    onClick={() => handleDownload(userFileUUID)}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "3px",
                                        padding: "2px 4px", // smaller padding
                                        fontSize: "10px",   // smaller text/icon
                                    }}
                                >
                                    <FaDownload style={{ fontSize: "12px" }} /> {/* smaller icon */}
                                </Button>

                            )}

                            {/* ✅ Play button OR audio */}
                            {src ? (
                                <audio
                                    ref={(el) => (audioRefs.current[userFileUUID] = el)}
                                    controls
                                    style={{ width: "200px" }}
                                >
                                    <source src={src} type="audio/mpeg" />
                                </audio>
                            ) : (
                                <button
                                    onClick={() => handleAudioPlay(userFileUUID)}
                                    style={{
                                        padding: "4px 8px",
                                        background: "#fff",
                                        color: "#000",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                    }}
                                >
                                    ▶
                                </button>
                            )}
                        </div>
                    );
                },
            }


        ],
        [audioSources]
    );

    const handleDownload = async (userFilesUUID) => {
        try {
            const res = await axios.get(
                `${downloadUserAudioRecordingAPIURL}?employeeUUID=${formik.values.employeeId}&audioFileUUID=${userFilesUUID}`,
                {
                    headers: { ...authUser.headers },
                }
            );

            if (res.data?.data) {
                const fileUrl = res.data.data;

                // ✅ Option 1: Trigger download
                const link = document.createElement("a");
                link.href = fileUrl;
                link.setAttribute("download", `${userFilesUUID}.m4a`); // extension from S3
                document.body.appendChild(link);
                link.click();
                link.remove();

                // ✅ Option 2: Play audio directly
                // const audio = new Audio(fileUrl);
                // audio.play();
            } else {
                throw new Error("No file URL received");
            }
        } catch (error) {
            console.error("Error downloading audio:", error);
            openPopup("Download failed!", "error");
        }
    };



    const handleAudioPlay = async (userFileUUID) => {
        // if (data.length !== 0) {
        try {
            const res = await axios.get(
                `${streamUserAudioRecordingAPIURL}?employeeUUID=${formik.values.employeeId}&audioFileUUID=${userFileUUID}`,
                {
                    headers: { ...authUser.headers },
                    Authorization: `Bearer ${authUser.headers.access_token}`,
                }
            );

            if (res.data.responseMsg == "Success") {
                const url = res.data.data;

                // Stop any other playing audio
                Object.values(audioRefs.current).forEach((audio) => {
                    if (audio && !audio.paused) {
                        audio.pause();
                        audio.currentTime = 0;
                    }
                });

                // Update state
                setAudioSources({ [userFileUUID]: url });

                // ✅ Wait for <audio> to render, then play
                setTimeout(() => {
                    const audioEl = audioRefs.current[userFileUUID];
                    if (audioEl) {
                        audioEl.load();
                        audioEl.play().catch((err) => {
                            console.warn("Autoplay blocked:", err);
                        });
                    }
                }, 200); // <-- small delay so React renders first
            }
        } catch (error) {
            openPopup("Something went wrong!", "error");
            console.error("Error fetching audio:", error);
        }
        // }
    };



    const [data, setData] = useState([]);
    const [submittedCallType, setSubmittedCallType] = useState("");
    const [pageNo, setPageNo] = useState(1);  // Track the current page number
    const [pageSize, setPageSize] = useState(10);  // Track page size
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');
    const customePageSize = [10, 20, 30, 40, 50]

    const [employeeData, setEmployeeData] = useState([]);
    const [employeeId, setEmployeeId] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loaderOption, setLoaderOption] = useState(false);
    const [disabelSaveBtn, setDisableSaveBtn] = useState(false);

    // Convert employees array to the format that react-select needs
    const employeeOptions = employeeData.map(emp => ({
        value: emp.userUUID,
        label: emp.userName
    }))

    // Handle the change for the employee ID
    const handleEmployeeIdChange = (e) => {
        setEmployeeId(e.target.value);
    }

    // Handle date change (for both startDate and endDate)
    const handleDateChange = (date, field) => {
        setData([]);
        formik.setFieldValue(field, date);
    };

    useEffect(() => {
        getData();
    }, [authUser]);


    const getData = async () => {
        setLoaderOption(true);
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {

            // console.log(`${getActiveUserListAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0`)
            try {
                const response = await axios.get(
                    `${getActiveUserListAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );
                // console.log(response.data.responseMsg)
                if (response.data.responseMsg == "Success") {
                    setEmployeeData(response.data.data.items);
                    setTotalPages(response.data.data.totalPages)
                    setTotalItems(response.data.data.totalItems);
                    setNextPage(response.data.data.nextPage);
                    setPreviousPage(response.data.data.previousPage);
                    setCurrentPage(response.data.data.currentPage);
                    setLoaderOption(false);
                }
                else {
                    console.error('API Response Error:', response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup('Something went wrong!', 'error')
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoaderOption(false);
                openPopup('Something went wrong!', 'error')
            }
            // finally {
            //     setLoaderOption(false);
            // }
        }
    };

    const handlePageChange = async (newPageNo, newPageSize) => {
        if (data.length != 0) {
            if (authUser.headers && Object.keys(authUser.headers).length > 0) {
                // console.log(`API URL: ${getUserAudioRecordingsAPIURL}?employeeUUID=${values.employeeId}&journeyDate=${moment(values.date).format("DD/MM/YYYY")}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}}`);

                try {
                    const response = await axios.get(
                        `${getUserAudioRecordingsAPIURL}?employeeUUID=${formik.values.employeeId}&startDate=${moment(formik.values.startDate).format("DD/MM/YYYY")}&endDate=${moment(formik.values.endDate).format("DD/MM/YYYY")}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`,
                        {
                            headers: { ...authUser.headers },
                            'Authorization': `Bearer ${authUser.headers.access_token}`
                        }
                    );

                    if (response.data.responseMsg == "Records not found") {
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup('Records Not Found.', 'error')
                    }
                    else if (response.data.responseMsg == "Success") {
                        setData(response.data.data.items);
                        setTotalPages(response.data.data.totalPages)
                        setTotalItems(response.data.data.totalItems);
                        setNextPage(response.data.data.nextPage);
                        setPreviousPage(response.data.data.previousPage);
                        setCurrentPage(response.data.data.currentPage);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                    }
                    else {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup(response.data.responseMsg, 'error')
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                    setLoaderOption(false);
                    setDisableSaveBtn(false);
                    openPopup("Requested Data Not Found / 404", 'warn')
                }
                //  finally {
                //     setLoaderOption(false);
                // }
            }
        }
    };

    const formik = useFormik({
        initialValues: {
            employeeId: '',
            startDate: new Date(),
            endDate: new Date(),
        },
        validationSchema: Yup.object({
            employeeId: Yup.string()
                .required('Employee is required'),

            startDate: Yup.date()
                .required('Start Date is required'),

            endDate: Yup.date()
                .required('End Date is required')
                .test(
                    "date-range",
                    "End Date should not be before Start Date and not more than 3 days later",
                    function (value) {
                        const { startDate } = this.parent;
                        if (startDate && value) {
                            const diff = moment(value).diff(moment(startDate), "days");

                            // ✅ allow same day (0), next days (1–3), but not negative
                            return diff >= 0 && diff < 2;
                        }
                        return true;
                    }
                ),
        }),


        onSubmit: async (values) => {
            setLoaderOption(true);
            setDisableSaveBtn(true);
            setData([]);
            setTotalPages('');
            setTotalItems('');
            setNextPage('');
            setPreviousPage('');
            setCurrentPage('');
            setAudioSrc(null);
            setAudioSources({});
            // console.log(values)
            if (authUser.headers && Object.keys(authUser.headers).length > 0) {
                // console.log(`API URL: ${getUserAudioRecordingsAPIURL}?employeeUUID=${values.employeeId}&startDate=${moment(values.startDate).format("DD/MM/YYYY")}&endDate=${moment(values.endDate).format("DD/MM/YYYY")}&pageNo=${pageNo}&perPageRec=${pageSize}`);

                try {
                    const response = await axios.get(
                        `${getUserAudioRecordingsAPIURL}?employeeUUID=${values.employeeId}&startDate=${moment(values.startDate).format("DD/MM/YYYY")}&endDate=${moment(values.endDate).format("DD/MM/YYYY")}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`,
                        {
                            headers: { ...authUser.headers },
                            'Authorization': `Bearer ${authUser.headers.access_token}`
                        }
                    );

                    if (response.data.responseMsg == "Records not found") {
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup('Records Not Found.', 'error')
                    }
                    else if (response.data.responseMsg == "Success") {
                        setData(response.data.data.items);
                        setTotalPages(response.data.data.totalPages)
                        setTotalItems(response.data.data.totalItems);
                        setNextPage(response.data.data.nextPage);
                        setPreviousPage(response.data.data.previousPage);
                        setCurrentPage(response.data.data.currentPage);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                    }
                    else {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup(response.data.responseMsg, 'error')
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                    setLoaderOption(false);
                    setDisableSaveBtn(false);
                    openPopup("Requested Data Not Found / 404", 'warn')
                }
                //  finally {
                //     setLoaderOption(false);
                // }
            }

        },
    });


    const handleEmployeeChange = (selectedOption) => {
        setData([]);
        formik.setFieldValue("startDate", new Date());
        formik.setFieldValue("endDate", new Date());
        setAudioSrc(null);
        const selectedEmployeeId = selectedOption ? selectedOption.value : '';
        formik.setFieldValue('employeeId', selectedEmployeeId);  // Set employeeId in formik state
    };

    const exportToExcel = async () => {
        setLoaderOption(true);
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            try {
                const response = await axios.get(
                    `${getUserAudioRecordingsAPIURL}?employeeUUID=${formik.values.employeeId}&startDate=${moment(formik.values.startDate).format("DD/MM/YYYY")}&endDate=${moment(formik.values.endDate).format("DD/MM/YYYY")}&isPagination=0&pageNo=0&perPageRec=0`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg == "Records not found") {
                    setLoaderOption(false);
                    openPopup("Records Not Found.", "error");
                } else if (response.data.responseMsg == "Success") {
                    const rawData = response.data.data.items; // API response data

                    if (!Array.isArray(rawData) || rawData.length == 0) {
                        setLoaderOption(false);
                        openPopup("No data available to export.", "error");
                        return;
                    }

                    // Convert JSON data to a worksheet
                    const ws = XLSX.utils.json_to_sheet(rawData);

                    // Create a new workbook and append the worksheet
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "User Wise Duration Report");

                    // Generate a timestamped filename
                    const currentDate = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })
                        .replace(",", "")
                        .replace(/\//g, "-")
                        .replace(/:/g, "-")
                        .split(" ")
                        .join("_");

                    const empName = employeeOptions.find(option => option.value == formik.values.employeeId);
                    const fileName = `${empName?.label || "Report"}_${currentDate}.xlsx`;

                    // Save the Excel file
                    XLSX.writeFile(wb, fileName);

                    setLoaderOption(false);
                } else {
                    console.error("API Response Error:", response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, "error");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoaderOption(false);
                openPopup("Requested Data Not Found / 404", 'warn')

            }
        }
    };


    if (!canRead) {
        return (
            <>
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Users" breadcrumbItem="Users Audio Recordings" />
                            <CantAccessPage />
                        </Container>
                    </div>
                </React.Fragment>
            </>
        )
    }
    else {
        if (loaderOption == true) {
            return (
                <>
                    <Loader />
                </>
            )
        }
        else {
            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Users" breadcrumbItem="Users Audio Recordings" />
                            <Card>
                                <CardBody className="border-bottom">
                                    <div style={{ padding: '20px' }}>

                                        <Form onSubmit={formik.handleSubmit}>
                                            <Row>
                                                {/* Employee Select */}
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="employeeId">User Name</Label>
                                                        <Select
                                                            id="employeeId"
                                                            name="employeeId"
                                                            className="form-control-md"
                                                            options={employeeOptions}
                                                            value={employeeOptions.find(option => option.value == formik.values.employeeId)}
                                                            onChange={handleEmployeeChange}
                                                            onBlur={formik.handleBlur}
                                                            placeholder="Select User Name"
                                                        />
                                                        {formik.touched.employeeId && formik.errors.employeeId && (
                                                            <div style={{ color: 'red', marginTop: '5px' }}>
                                                                {formik.errors.employeeId}
                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                </Col>

                                            </Row>

                                            <Row className='my-3'>
                                                {/* From Date Picker */}
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="startDate">Start Date</Label>

                                                        <DatePicker
                                                            selected={formik.values.startDate}
                                                            onChange={(date) => {
                                                                handleDateChange(date, "startDate");
                                                                formik.setFieldValue("endDate", "");
                                                            }}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="Select Start Date"
                                                            popperPlacement="bottom"
                                                            portalId="root"
                                                            renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        padding: "8px 12px",
                                                                        borderBottom: "1px solid #eee",
                                                                        background: "#fff",
                                                                    }}
                                                                >
                                                                    <button
                                                                        onClick={decreaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ◀
                                                                    </button>

                                                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                                        {date.toLocaleDateString("en-US", {
                                                                            month: "long",
                                                                            year: "numeric",
                                                                        })}
                                                                    </span>

                                                                    <button
                                                                        onClick={increaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ▶
                                                                    </button>
                                                                </div>
                                                            )}
                                                        />

                                                        {formik.touched.startDate && formik.errors.startDate && (
                                                            <div style={{ color: "red", marginTop: "5px" }}>
                                                                {formik.errors.startDate}
                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                </Col>


                                                {/* To Date Picker */}
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="endDate">End Date</Label>
                                                        <DatePicker
                                                            selected={formik.values.endDate}
                                                            onChange={(date) => handleDateChange(date, 'endDate')}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="Select End Date"
                                                            popperPlacement="bottom"
                                                            portalId="root"
                                                            renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        padding: "8px 12px",
                                                                        borderBottom: "1px solid #eee",
                                                                        background: "#fff",
                                                                    }}
                                                                >
                                                                    <button
                                                                        onClick={decreaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ◀
                                                                    </button>

                                                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                                        {date.toLocaleDateString("en-US", {
                                                                            month: "long",
                                                                            year: "numeric",
                                                                        })}
                                                                    </span>

                                                                    <button
                                                                        onClick={increaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ▶
                                                                    </button>
                                                                </div>
                                                            )}
                                                        />
                                                        {formik.touched.endDate && formik.errors.endDate && (
                                                            <div style={{ color: 'red', marginTop: '5px' }}>
                                                                {formik.errors.endDate}
                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <Row className="mt-3">
                                                {/* Submit Button */}
                                                <Col md="12">
                                                    <Button color="primary" type="submit" disabled={disabelSaveBtn || !canRead}>
                                                        Submit
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>

                                    {
                                        data.length != 0
                                            ?
                                            <div className='mt-3'>
                                                <div className="d-flex align-items-center justify-content-end mb-2">
                                                    <div className="flex-shrink-0">
                                                        <button
                                                            onClick={exportToExcel}  // Trigger the export function
                                                            className="btn btn-primary me-1"
                                                        >
                                                            Export Excel
                                                        </button>
                                                    </div>
                                                </div>
                                                <TableContainer
                                                    columns={columns}
                                                    data={data || []}
                                                    isGlobalFilter={true}
                                                    isPagination={true}
                                                    SearchPlaceholder="Search..."
                                                    isCustomPageSize={true}
                                                    tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                    theadClass="table-light"
                                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                    pagination="pagination"
                                                    getRowProps={row => ({
                                                        className: "",
                                                    })}
                                                    onPageChange={handlePageChange} // Pass page change handler
                                                    onPageSizeChange={handlePageChange} // Pass page size change handler
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    totalPages={totalPages}
                                                    totalItems={totalItems}
                                                    tableNextPage={nextPage}
                                                    tablePreviousPage={previousPage}
                                                    tableCurrentPage={currentPage}
                                                    customePageSize={customePageSize}

                                                />
                                            </div>
                                            :
                                            ''
                                    }
                                </CardBody>
                            </Card>
                        </Container>
                    </div>

                    {isPopupVisible && (
                        <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                    )}
                </React.Fragment>
            );
        }
    }
}

UsersAudioRecordings.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(UsersAudioRecordings);

